// extracted by mini-css-extract-plugin
module.exports = {"bodyreset":"buttons_bodyreset__1w81A","removepadding":"buttons_removepadding__iqHDT","crossButton":"buttons_crossButton__24wpS"};